<template>
  <v-btn
    @click="$emit('click')"
    :disabled="disabled"
    :loading="loading"
    color="white"
    fab
    class="location-button"
    :class="{ aerial: viewIsAerial }"
  >
    <v-icon>location_searching</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "CenterLocationButton",

  props: {
    /**
     * Defines if the button is disabled or not
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Define if the button is loading
     */
    loading: {
      type: Boolean,
      default: false
    },

    /**
     * Determines whether the map view is Aerial or not
     */
    viewIsAerial: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style scoped>
.location-button {
  position: absolute !important;
  z-index: 1 !important;
  left: 1px !important;
  top: 79px !important;
  height: 35px !important;
  width: 35px !important;
  margin: 6px 8px !important;
}

.location-button.v-btn.v-btn--disabled.v-btn--floating.theme--light.white--text.aerial {
  background-color: rgba(255, 255, 255, 0.5) !important;
}

.location-button:focus::before {
  opacity: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/_Atoms/CenterLocationButton.vue